﻿<template>
  <div id="app">
    <Header-el></Header-el>
    <div class="appOnLink-main">
      <div class="bannerShow">
        <div class="wrapper clearfix">
          <div class="fl">
            <router-link to="/index.html" title="星达首页">
              <div class="icon-logo logo"></div>
            </router-link>
            <h2 class="icon-subShow"></h2>
            <div class="appDownLoad clearfix">
              <div class="appDownButton">
                <a href="https://apps.apple.com/cn/app/%E6%98%9F%E8%BE%BE-%E6%BD%AE%E6%B5%81%E8%BF%90%E5%8A%A8%E7%A4%BE%E5%8C%BA/id1490821060" target="_blank"><img style="width:170px;background-color: black" src="/images/iosdownload.png"> </a>
                <a href="http://app.mi.com/details?id=com.asstar.app"  target="_blank"> <img style="width:170px;background-color: black"  src="/images/androiddownload.png"></a>
              </div>
              <div class="appKeyCode">
                <img style="width:170px;" src="/images/keyCode.jpg">
              </div>
            </div>
          </div>
          <div class="pictureShow clearfix fl">
            <span class="pictureShow1"><img src="/images/app-page-show2.png" /></span>
            <span class="pictureShow2"><img src="/images/app-page-show1.png" /></span>
          </div>  
        </div>
      </div>
      <div class="enjoyListShow">
        <div class="layerBg"></div>
        <div class="enjoyList" style="width: 1200px; margin: -105px auto;margin-bottom: 20px">
          <h2>我们的服务</h2>
          <ul class="clearfix">
            <li class="listShow1">
              <i class="icon-enjoy1"></i>
              <h3>电商营销服务</h3>
              <p>海内外多渠道的广告营销方案</p>
            </li>
            <li class="listShow2">
              <i class="icon-enjoy2"></i>
              <h3>安全仓储</h3>
              <p>享受仓储周转，快速交易有保障</p>
            </li>
            <li class="listShow3">
              <i class="icon-enjoy3"></i>
              <h3>快速回款</h3>
              <p>鉴别通过后可立即出售或转卖，回款无账期</p>
            </li>
            <li class="listShow4">
              <i class="icon-enjoy4"></i>
              <h3>鉴别服务</h3>
              <p>平台免费负责鉴别真伪，帮助快速售出</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer-el/>
  </div>

</template>
<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  name: "app",
  components: {
    "Header-el": Header,
    "Footer-el": Footer,
    //swiper:swiper
  },
};
</script>
<style scoped>
body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, form, fieldset, textarea, p, blockquote, th, td, iframe, span, a, strong, input, select, textarea, img, table {
  margin: 0;
  padding: 0;
}
body {
  font-size: 12px;
  text-align: left;
  margin: 0 auto;
  padding: 0;
  color: #000;
  -webkit-text-size-adjust: none;
  font-family: black;
}
ul, li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
a {
  text-decoration: underline;
  outline: none;
}
fieldset,
img {
  border: 0;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.wrapper {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
[class*="icon-"] {
  background: url(/images/cssSprites.png) no-repeat;
}
.appOnLink-main .bannerShow {
  width: 100%; min-width: 1200px;
  background: #ff2121;
  padding: 50px 0;
}
.logo {
  width: 120px;
  height: 162px;
  margin-left: 184px;
  margin-top: 18px;
}
.icon-subShow {
  width: 414px;
  height: 31px;
  background-position: 0 -171px;
  margin-top: 51px;
  margin-left: 37px;
}
.appDownLoad {
  margin: 99px 0 0 37px;
  display: flex;
}
.appDownLoad .appDownButton{
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-around;
  padding: 15px 0px;
}
.appDownLoad .appDownButton a {
  display: block;
  width: 170px; height:55px; -webkit-transition: all 0.25s ease-out .2s;
  transition: all 0.25s ease-out .2s;
}
.appDownLoad .appDownButton a:hover {
  transform: translateY(-6px); -webkit-transform: translateY(-6px);
  box-shadow: 0 0 20px 0 rgba(51, 51, 51, 0.20);
}
.appDownLoad .appDownButton a.appstore {
  background-position: -130px 0;
  margin: 7px 0 25px 0;
}
.appDownLoad .appDownButton a.andorid {
  background-position: -130px -76px;
}
.appDownLoad .appKeyCode {
  margin-left: 19px;
}
.pictureShow {
  background: url(/images/picture-show-shadow.png) no-repeat bottom;
  height: 607px;
  width: 748px;
}
.pictureShow .pictureShow1 {
  margin-left: 92px;
}
.pictureShow .pictureShow2 {
  margin-left: 30px;
}
.pictureShow span img{width: 280px; padding-top: 25px;}
.enjoyListShow {
  background: #fff;
  padding-bottom: 50px;
}
.enjoyListShow .layerBg {
  width: 100%;
  height: 105px;
  background: #ff2121;
}
.enjoyListShow .enjoyList {
  background: #fff;
  height: 325px;
  border-radius: 24px;
  margin-top: -105px;
  -webkit-box-shadow: 0 10px 7px rgba(255, 241, 241, 0.8);
  -moz-box-shadow: 0 10px 7px rgba(255, 241, 241, 0.8);
  -ms-box-shadow: 0 10px 7px rgba(255, 241, 241, 0.8);
  box-shadow: 0 10px 7px rgba(255, 241, 241, 0.8);
  overflow: hidden;
}
.enjoyListShow .enjoyList h2 {
  text-align: center;
  color: #000;
  font-size: 24px;
  margin: 38px 0 30px 0;
}
.enjoyListShow .enjoyList ul {
  margin-left: 64px;
}
.enjoyListShow .enjoyList ul li {
  float: left;
  text-align: center;
  margin-right: 68px;
}
.enjoyListShow .enjoyList ul li.listShow4 {
  margin-right: 0;
}
.enjoyListShow .enjoyList ul li i {
  display: inline-block;
}
.enjoyListShow .enjoyList ul li h3 {
  font-size: 18px;
  margin-bottom: 12px;
}
.enjoyListShow .enjoyList ul li p {
  font-size: 14px;
}
.enjoyListShow .enjoyList ul li .icon-enjoy1 {
  width: 119px;
  height: 95px;
  background-position: -366px 0;
  margin-bottom: 24px;
}
.enjoyListShow .enjoyList ul li .icon-enjoy2 {
  width: 112px;
  height: 99px;
  background-position: -130px -212px;
  margin-bottom: 20px;
}
.enjoyListShow .enjoyList ul li .icon-enjoy3 {
  width: 104px;
  height: 99px;
  background-position: 0 -212px;
  margin-bottom: 20px;
}
.enjoyListShow .enjoyList ul li .icon-enjoy4 {
  width: 100px;
  height: 100px;
  background-position: -252px -212px;
  margin-bottom: 19px;
}
.footer {
  background: #fff;
  padding-bottom: 95px;
  text-align: center;
}
.contactUs {
  font-size: 13px;
}
.footer p {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
</style>
